import React, { useReducer } from 'react';
import {
  BlogsCardContainer,
  StyledBlogs,
  StyledBlogsButtonsContainer,
  StyledBlogsButton,
} from '../styles/Blogs.styled';
import { SectionHeading, SectionTitle } from '../styles/SectionHeading';
import { StyledParagraph } from '../styles/Typography.styled';
import BlogsCardComponent from './BlogsCard';
import { BlogsData } from './BlogsData';

const countReducer = (count, { type }) => {
  if (type === 'increase') {
    return count + 4;
  } else if (type === 'decrease') {
    if (count > BlogsData.length && BlogsData.length % 4) {
      return BlogsData.length - (BlogsData.length % 4);
    }
    return count - 4;
  } else {
    return count;
  }
};

const Blogs = () => {
  const [count, dispatchCount] = useReducer(countReducer, 4);

  return (
    <StyledBlogs id="blogs">
      <SectionHeading>
        <SectionTitle number="03">Blogs</SectionTitle>
      </SectionHeading>
      <StyledParagraph dark="true" textAlign="center">
        Several blogs I've penned in my spare time.
      </StyledParagraph>
      <BlogsCardContainer>
        {BlogsData.slice(0, count).map((project, index) => {
          return <BlogsCardComponent key={index} {...project} />;
        })}
      </BlogsCardContainer>
      <StyledBlogsButtonsContainer>
        {count > 4 && (
          <StyledBlogsButton
            onClick={() => dispatchCount({ type: 'decrease' })}
          >
            <span>Show Less</span>
          </StyledBlogsButton>
        )}
        {count < BlogsData.length && (
          <StyledBlogsButton
            secondary="true"
            onClick={() => dispatchCount({ type: 'increase' })}
          >
            <span>Show more</span>
          </StyledBlogsButton>
        )}
      </StyledBlogsButtonsContainer>
    </StyledBlogs>
  );
};

export default Blogs;
